export default __webpack_public_path__ + "static/media/Pratt_Whitney.f38941c0.png";